import { render, staticRenderFns } from "./mjl.vue?vue&type=template&id=77afb3a3"
import script from "./mjl.vue?vue&type=script&lang=js"
export * from "./mjl.vue?vue&type=script&lang=js"
import style0 from "./mjl.vue?vue&type=style&index=0&id=77afb3a3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports